<template>
  <!-- 可选飞机信息表格 -->
  <div class="flight-main1">
    <!-- 推荐组合 -->
    <template v-if="getTabName == 'first'">
      <template v-for="(item, i) in flightList">
        <div class="flight_info_wrap free_flight_info_wrap clearfix" :key="i">
          <div class="free_flight_info clearfix">
            <!-- 航班 -->
            <div class="first">
              <!-- 航班logo -->
              <div class="flight_logo">
                <!-- img
                src="http://m.tuniucdn.com/fb2/t1/G1/M00/C4/44/Cii9EFagbqqIJd1SAABFaAPRoW0AABkWgCKC4wAAEWA246.png"
                alt=""
              / -->
              </div>
              <!-- 航班简介 -->
              <div class="flight_brief">
                <!-- 航司名称 -->
                <div class="name">
                  {{ item.inlandFlightItemInfoLists[0].airlineCompany }}
                </div>
                <!-- 航班公司 -->
                <div class="flight_detail clearfix">
                  <!-- 航班编号 -->
                  <div class="number">
                    {{
                      item.inlandFlightItemInfoLists[0].flightNo +
                      " " +
                      item.inlandFlightItemInfoLists[0].airplaneTypeName
                    }}
                  </div>
                  <!-- 航班详情 -->
                  <div class="detail_info">
                    <!-- 标题 -->
                    <span
                      class="detail_name"
                      @mouseover="hover = 'flightDetail' + i"
                      @mouseleave="hover = 'none'"
                    >
                      <img
                        class="flight_ico"
                        src="~@/assets/img/flight_ico1.png"
                      />
                      <span>航班详情</span>
                    </span>

                    <!-- 航班详情弹框 -->
                    <div
                      class="flight_detail_tooltip_wrap"
                      v-show="hover == 'flightDetail' + i"
                      @mouseover="hover = 'flightDetail' + i"
                      @mouseleave="hover = 'none'"
                    >
                      <div class="detail_tooltip">
                        <!-- 小三角 -->
                        <div class="flight_model_triangle_border">
                          <!--ie6下需用，非ie6无需-->
                          <!-- <i class="before"></i><i class="after"></i> -->
                        </div>

                        <!-- 日期 -->
                        <div v-if="!item.journeyType" class="date">
                          {{ item.inlandFlightItemInfoLists[0].departureDate }}
                        </div>
                        <!-- 航班列表 -->
                        <template v-if="item.journeyType">
                          <div
                            v-for="(
                              item10, i10
                            ) in item.transferInfos"
                            :key="i10"
                            class="flight_detail_list"
                          >
                            <!-- 小飞机加城市名 -->
                            <div class="city">
                              <img
                                class="fligtico"
                                src="~@/assets/img/flight_ico2.png"
                              />
                              {{ item10.dcityName }}

                              <img
                                class="arrow_icon"
                                src="~@/assets/img/arrow_icon1.png"
                              />

                              {{ item10.acityName }}
                            </div>
                            <!-- 航班详细信息 -->
                            <div class="info clearfix">
                              <!-- 起飞时间和机场 -->
                              <div class="start">
                                <div class="time">
                                  {{ item10.departTime }}
                                </div>
                                <div class="name">
                                  {{ item10.dportName
                                  }}{{ item10.terminalDeparture }}
                                </div>
                              </div>
                              <!-- 经历时间 -->
                              <div class="interval">
                                <div>
                                  {{ formatTime(1,item10.departTime,item10.arriveTime) }}
                                </div>
                                <img
                                  class="arrow_icon_big"
                                  src="~@/assets/img/arrow_icon_big.png"
                                />
                              </div>
                              <!-- 到达时间和机场 -->
                              <div class="end">
                                <div class="time">{{ item10.arriveTime }}</div>
                                <div class="name">
                                  {{ item10.aportName
                                  }}{{ item10.terminalArrival }}
                                </div>
                              </div>
                              <!-- 航空公司 -->
                              <div class="company">
                                {{ item10.airlineCompany }}
                                {{ item10.flightNo }}
                                {{ item10.airplaneTypeName }}
                              </div>
                            </div>
                          </div>
                        </template>
                        <template v-else>
                        <div
                          v-for="(
                            item10, i10
                          ) in item.inlandFlightItemInfoLists"
                          :key="i10"
                          class="flight_detail_list"
                        >
                          <!-- 小飞机加城市名 -->
                          <div class="city">
                            <img
                              class="fligtico"
                              src="~@/assets/img/flight_ico2.png"
                            />
                            {{ item10.departureCityName }}

                            <img
                              class="arrow_icon"
                              src="~@/assets/img/arrow_icon1.png"
                            />

                            {{ item10.destinationCityName }}
                          </div>
                          <!-- 航班详细信息 -->
                          <div class="info clearfix">
                            <!-- 起飞时间和机场 -->
                            <div class="start">
                              <div class="time">
                                {{ item10.departureTime }}
                              </div>
                              <div class="name">
                                {{ item10.dportName
                                }}{{ item10.terminalDeparture }}
                              </div>
                            </div>
                            <!-- 经历时间 -->
                            <div class="interval">
                              <div>
                                {{ formatTime(item10.duration) }}
                              </div>
                              <img
                                class="arrow_icon_big"
                                src="~@/assets/img/arrow_icon_big.png"
                              />
                            </div>
                            <!-- 到达时间和机场 -->
                            <div class="end">
                              <div class="time">{{ item10.arrivalTime }}</div>
                              <div class="name">
                                {{ item10.aportName
                                }}{{ item10.terminalArrival }}
                              </div>
                            </div>
                            <!-- 航空公司 -->
                            <div class="company">
                              {{ item10.airlineCompany }}
                              {{ item10.flightNo }}
                              {{ item10.airplaneTypeName }}
                            </div>
                          </div>
                        </div>
                        </template>
                        <div class="bookInfo" v-if="item.bookInfo">
                          <div class="title">购票说明:</div>
                          <div class="detail">{{ item.bookInfo }}</div>
                        </div>
                        <div
                          class="bookInfo"
                          v-if="item.priceFlightCabinList[0].baggageInfo"
                        >
                          <div class="title">行李额:</div>
                          <div class="detail">
                            {{ item.priceFlightCabinList[0].baggageInfo }}
                          </div>
                        </div>
                        <div class="bookInfo">
                          <div class="title">退改签信息:</div>
                          <div class="detail">不退不改</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 起飞时间-->
            <div class="second">
              <div class="time">
                {{ item.inlandFlightItemInfoLists[0].departureTime }}
              </div>
              <div class="address">
                {{
                  item.inlandFlightItemInfoLists[0].dportName +
                  item.inlandFlightItemInfoLists[0].terminalDeparture
                }}
              </div>
            </div>
            <!-- 飞行区间 -->
            <div class="third">
              <div class="top" v-if="item.transferFlag">
                {{ formatTime(item.durationTime) }}
              </div>
              <div class="top" v-else>
                {{ formatTime(item.inlandFlightItemInfoLists[0].duration) }}
              </div>
              <img
                class="arrow_icon_big"
                src="~@/assets/img/arrow_icon_big.png"
              />
              <!-- 经停 -->
              <div
                class="bottom"
                v-if="item.inlandFlightItemInfoLists[0].stopNum > 0"
              >
                <span
                  class="title"
                  @mouseover="hover = 'duration' + i"
                  @mouseleave="hover = 'none'"
                >
                {{ item.journeyType == 1 ? '华夏通程' : (item.journeyType == 2 ? '华夏联程' : '经停') }} · {{ item.stopInfo }}</span
                >
                <div
                  class="tooltiptrans_wrap"
                  v-show="hover == 'duration' + i"
                  @mouseover="hover = 'duration' + i"
                  @mouseleave="hover = 'none'"
                >
                  <div class="tooltiptrans">
                    <!-- 小三角 -->
                    <div class="flight_model_triangle_border">
                      <!--ie6下需用，非ie6无需-->
                      <!-- <i class="before"></i><i class="after"></i> -->
                    </div>
                    <div class="item">
                      {{ item.journeyType ? '中转' : '经停' }}城市：{{ item.stopInfo }}
                    </div>
                    <div class="item">
                      {{ item.journeyType ? '中转' : '经停' }}机场：{{ item.stopstopAirPointInfo }}
                    </div>
                    <div class="item">
                      {{ item.journeyType ? '中转' : '经停' }}时长：{{ item.stopTime }}
                    </div>
                  </div>
                </div>
              </div>
              <!-- 中转 -->
              <div class="bottom" v-if="item.transferFlag">
                <span
                  class="title"
                  @mouseover="hover = 'duration' + i"
                  @mouseleave="hover = 'none'"
                  >转 · {{ item.transferAddressStr }}</span
                >
                <div
                  class="tooltiptrans_wrap"
                  v-show="hover == 'duration' + i"
                  @mouseover="hover = 'duration' + i"
                  @mouseleave="hover = 'none'"
                >
                  <div class="tooltiptrans">
                    <!-- 小三角 -->
                    <div class="flight_model_triangle_border">
                      <!--ie6下需用，非ie6无需-->
                      <!-- <i class="before"></i><i class="after"></i> -->
                    </div>
                    <div class="item">
                      中转机场：{{ item.transferAddressStr }}
                    </div>
                    <div class="item">停留时长：{{ item.transferTimeStr }}</div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 到达时间 -->
            <div class="forth">
              <div class="time">
                {{
                  item.inlandFlightItemInfoLists[item.flightLength - 1]
                    .arrivalTime
                }}
                <div class="time_popover_wrap">
                  <span
                    class="right_top"
                    @mouseover="hover = 'stop' + i"
                    @mouseleave="hover = 'none'"
                    v-if="item.inlandFlightItemInfoLists[0].addDay"
                    >+1</span
                  >
                  <div
                    class="time_popover"
                    v-show="hover == 'stop' + i"
                    @mouseover="hover = 'stop' + i"
                    @mouseleave="hover = 'none'"
                  >
                    <div class="time_popover_inner">
                      <!-- 小三角 -->
                      <div class="flight_model_triangle_border">
                        <!--ie6下需用，非ie6无需-->
                        <!-- <i class="before"></i><i class="after"></i> -->
                      </div>
                      到达时间为{{
                        item.inlandFlightItemInfoLists[item.flightLength - 1]
                          .arrivedateAndTime
                      }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="address">
                {{
                  item.inlandFlightItemInfoLists[item.flightLength - 1]
                    .aportName +
                  item.inlandFlightItemInfoLists[item.flightLength - 1]
                    .terminalArrival
                }}
              </div>
            </div>
            <!-- 金额 -->
            <div class="fifth">
              <span class="add" v-if="item.isInt">+</span>
              <span class="add" v-else>-</span>
              <span class="unit">¥</span>
              <span class="number">{{ item.diffPrice }}</span>
              <span class="qi">起</span>
            </div>
            <!-- 操作 -->

            <template v-if="item.isSelectedTicket">
              <div class="sixth1 sixth1-selected">
                <div
                  @click="
                    chosedTicket(item, null, item.diffPrice, item.isInt, i)
                  "
                >
                  已选第{{ getCurrent() }}程
                </div>
              </div>
            </template>
            <template v-else>
              <div class="sixth1">
                <div
                  @click="
                    chosedTicket(item, null, item.diffPrice, item.isInt, i)
                  "
                >
                  选为第{{ getCurrent() }}程
                </div>
              </div>
            </template>
          </div>
        </div>
      </template>
    </template>
    <!-- 自由组合 -->
    <div v-else>
      <template v-if="flightList.length > 0">
        <template v-for="(item, i) in flightList">
          <div
            class="flight_info_wrap free_flight_info_wrap"
            :class="{ chosed_warp: item.isSelectedTicket === 1 }"
            :key="i"
          >
            <div class="free_flight_info clearfix">
              <!-- 航班 -->
              <div class="first">
                <!-- 航班logo -->
                <div class="flight_logo">
                  <img :src="item.inlandConnectionInfoList[0].airComImageUrl" />
                </div>
                <!-- 航班简介 -->
                <div class="flight_brief">
                  <!-- 航司名称 -->
                  <div class="name">
                    {{ item.inlandConnectionInfoList[0].airlineCompany }}
                  </div>
                  <!-- 航班公司 -->
                  <div class="flight_detail clearfix">
                    <!-- 航班编号 -->
                    <div class="number">
                      {{
                        item.inlandConnectionInfoList[0].flightNo +
                        " " +
                        item.inlandConnectionInfoList[0].airplaneType
                      }}
                    </div>
                    <!-- 航班详情 -->
                    <div class="detail_info">
                      <!-- 标题 -->
                      <span
                        v-if="item.inlandConnectionInfoList[0].codeShare || item.transferFlag == 1 && item.inlandConnectionInfoList[1].codeShare"
                        class="detail_name"
                        @mouseover="hover = 'shareFlight' + i"
                        @mouseleave="hover = 'none'"
                      >
                      (共享)
                      </span>
                      <span
                        class="detail_name"
                        @mouseover="hover = 'flightDetail' + i"
                        @mouseleave="hover = 'none'"
                      >
                        <img
                          class="flight_ico"
                          src="~@/assets/img/flight_ico1.png"
                        />
                        <span>航班详情</span>
                      </span>
                      <!-- 航班详情弹框 -->
                      <div
                        class="flight_detail_tooltip_wrap"
                        v-show="hover == 'flightDetail' + i"
                        @mouseover="hover = 'flightDetail' + i"
                        @mouseleave="hover = 'none'"
                      >
                        <div class="detail_tooltip">
                          <!-- 小三角 -->
                          <div class="flight_model_triangle_border">
                            <!--ie6下需用，非ie6无需-->
                            <!-- <i class="before"></i><i class="after"></i> -->
                          </div>
                          <!-- 日期 -->
                          <div v-if="!item.journeyType" class="date">
                            {{ item.inlandConnectionInfoList[0].departureDate }}
                          </div>
                          <!-- 航班列表 -->
                          <template v-if="item.journeyType">
                          <div
                            v-for="(
                              item10, i10
                            ) in item.transferInfos"
                            :key="i10"
                            class="flight_detail_list"
                          >
                            <!-- 小飞机加城市名 -->
                            <div class="city">
                              <img
                                class="fligtico"
                                src="~@/assets/img/flight_ico2.png"
                              />
                              {{ item10.dcityName }}

                              <img
                                class="arrow_icon"
                                src="~@/assets/img/arrow_icon1.png"
                              />

                              {{ item10.acityName }}
                            </div>
                            <!-- 航班详细信息 -->
                            <div class="info clearfix">
                              <!-- 起飞时间和机场 -->
                              <div class="start">
                                <div class="time">
                                  {{ item10.departTime }}
                                </div>
                                <div class="name">
                                  {{ item10.dportName
                                  }}{{ item10.terminalDeparture }}
                                </div>
                              </div>
                              <!-- 经历时间 -->
                              <div class="interval">
                                <div>
                                  {{ formatTime(1,item10.departTime,item10.arriveTime) }}
                                </div>
                                <img
                                  class="arrow_icon_big"
                                  src="~@/assets/img/arrow_icon_big.png"
                                />
                              </div>
                              <!-- 到达时间和机场 -->
                              <div class="end">
                                <div class="time">{{ item10.arriveTime }}</div>
                                <div class="name">
                                  {{ item10.aportName
                                  }}{{ item10.terminalArrival }}
                                </div>
                              </div>
                              <!-- 航空公司 -->
                              <div class="company">
                                {{ item10.airlineCompany }}
                                {{ item10.flightNo }}
                                {{ item10.airplaneTypeName }}
                              </div>
                            </div>
                          </div>
                          </template>
                          <template v-else>
                          <div
                            v-for="(
                              item10, i10
                            ) in item.inlandConnectionInfoList"
                            :key="i10"
                            class="flight_detail_list"
                          >
                            <!-- 小飞机加城市名 -->
                            <div class="city">
                              <img
                                class="fligtico"
                                src="~@/assets/img/flight_ico2.png"
                              />
                              {{ item10.departureCityName }}

                              <img
                                class="arrow_icon"
                                src="~@/assets/img/arrow_icon1.png"
                              />

                              {{ item10.destinationCityName }}
                            </div>
                            <!-- 航班详细信息 -->
                            <div class="info clearfix">
                              <!-- 起飞时间和机场 -->
                              <div class="start">
                                <div class="time">
                                  {{ item10.departureTime }}
                                </div>
                                <div class="name">
                                  {{ item10.dportName
                                  }}{{ item10.terminalDeparture }}
                                </div>
                              </div>
                              <!-- 经历时间 -->
                              <div class="interval">
                                <div>
                                  {{ formatTime(item10.duration) }}
                                </div>
                                <img
                                  class="arrow_icon_big"
                                  src="~@/assets/img/arrow_icon_big.png"
                                />
                              </div>
                              <!-- 到达时间和机场 -->
                              <div class="end">
                                <div class="time">{{ item10.arrivalTime }}</div>
                                <div class="name">
                                  {{ item10.aportName
                                  }}{{ item10.terminalArrival }}
                                </div>
                              </div>
                              <!-- 航空公司 -->
                              <div class="company">
                                {{ item10.airlineCompany }}
                                {{ item10.flightNo }}
                                {{ item10.airplaneTypeName }}
                              </div>
                            </div>
                            </div>
                          </template>
                        </div>
                      </div>
                      <!-- 共享航班信息 -->
                      <div
                        class="flight_detail_tooltip_wrap"
                        v-show="hover == 'shareFlight' + i"
                        @mouseover="hover = 'shareFlight' + i"
                        @mouseleave="hover = 'none'"
                      >
                        <div class="detail_tooltip">
                          <div class="flight_model_triangle_border"></div>
                          <template v-for="(share,s) in item.inlandConnectionInfoList" >
                            <div v-if="share.codeShare" :key="s">
                              {{'实际由' + share.shareAirlineName + share.codeShare + '承运'}}
                            </div>
                          </template>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 起飞时间-->
              <div class="second">
                <div class="time">
                  {{ item.inlandConnectionInfoList[0].departureTime }}
                </div>
                <div class="address">
                  {{ item.inlandConnectionInfoList[0].dportName
                  }}{{ item.inlandConnectionInfoList[0].terminalDeparture }}
                </div>
              </div>
              <!-- 飞行区间 -->
              <div class="third">
                <div class="top" v-if="item.transferFlag">
                  {{ formatTime(item.durationTime) }}
                </div>
                <div class="top" v-else>
                    {{ formatTime(item.inlandConnectionInfoList[0].duration) }}
                </div>
                <img
                  class="arrow_icon_big"
                  src="~@/assets/img/arrow_icon_big.png"
                />
                <!-- 经停 华夏通程/联程 -->
                <div
                  class="bottom"
                  v-if="item.inlandConnectionInfoList[0].stopNum"
                >
                  <span
                    class="title"
                    @mouseover="hover = 'duration' + i"
                    @mouseleave="hover = 'none'"
                  >
                    {{ item.journeyType == 1 ? '华夏通程' : (item.journeyType == 2 ? '华夏联程' : '经停') }} · {{ item.stopPointsStr }}</span
                  >
                  <div
                    class="tooltiptrans_wrap"
                    v-show="hover == 'duration' + i"
                    @mouseover="hover = 'duration' + i"
                    @mouseleave="hover = 'none'"
                  >
                    <div class="tooltiptrans">
                      <!-- 小三角 -->
                      <div class="flight_model_triangle_border">
                        <!--ie6下需用，非ie6无需-->
                        <!-- <i class="before"></i><i class="after"></i> -->
                      </div>
                      <div
                        v-for="(item11, i11) in item.inlandConnectionInfoList[0]
                          .stopPoints"
                        :key="i11"
                      >
                        <div class="item">
                          {{ item.journeyType ? '中转' : '经停' }}城市：{{ item11.cityName }}
                        </div>
                        <div class="item">
                          {{ item.journeyType ? '中转' : '经停' }}机场：{{ item11.airPortName }}
                        </div>
                        <div class="item">
                          {{ item.journeyType ? '中转' : '经停' }}时长：{{ formatTime(item11.duration) }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 中转 -->
                <div class="bottom" v-if="item.transferFlag">
                  <span
                    class="title"
                    @mouseover="hover = 'duration' + i"
                    @mouseleave="hover = 'none'"
                    >转 · {{ item.transferAddressStr }}</span
                  >
                  <div
                    class="tooltiptrans_wrap"
                    v-show="hover == 'duration' + i"
                    @mouseover="hover = 'duration' + i"
                    @mouseleave="hover = 'none'"
                  >
                    <div class="tooltiptrans">
                      <!-- 小三角 -->
                      <div class="flight_model_triangle_border">
                        <!--ie6下需用，非ie6无需-->
                        <!-- <i class="before"></i><i class="after"></i> -->
                      </div>
                      <div class="item">
                        中转城市：{{
                          item.inlandConnectionInfoList[0].destinationCityName
                        }}
                      </div>
                      <div class="item">
                        中转机场：{{
                          item.inlandConnectionInfoList[0].aportName
                        }}
                      </div>
                      <div class="item">
                        停留时长：{{
                          formatTime(item.inlandTransferInfoList[0].transferTime)
                        }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 到达时间 -->
              <div class="forth">
                <div class="time">
                  {{
                    item.inlandConnectionInfoList[item.flightLength - 1]
                      .arrivalTime
                  }}
                  <div class="time_popover_wrap">
                    <span
                      class="right_top"
                      @mouseover="hover = 'stop' + i"
                      @mouseleave="hover = 'none'"
                      v-if="item.inlandConnectionInfoList[0].addDay"
                      >+1</span
                    >

                    <div
                      class="time_popover"
                      v-show="hover == 'stop' + i"
                      @mouseover="hover = 'stop' + i"
                      @mouseleave="hover = 'none'"
                    >
                      <div class="time_popover_inner">
                        <!-- 小三角 -->
                        <div class="flight_model_triangle_border">
                          <!--ie6下需用，非ie6无需-->
                          <!-- <i class="before"></i><i class="after"></i> -->
                        </div>
                        到达时间为{{
                          item.inlandConnectionInfoList[item.flightLength - 1]
                            .arrivedateAndTime
                        }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="address">
                  {{ item.inlandConnectionInfoList[0].aportName
                  }}{{ item.inlandConnectionInfoList[0].terminalArrival }}
                </div>
              </div>
              <!-- 金额 -->
              <div class="fifth">
                <span class="add" v-if="item.isInt">+</span>
                <span class="add" v-else>-</span>
                <span class="unit">¥</span>
                <span class="number">{{ item.diffprice }} </span>
                <span class="qi">起</span>
              </div>
              <!-- 操作 -->

              <div
                class="sixth"
                :class="{ 'six-checked': item.isSelectedTicket === 1 }"
              >
                <div
                  @click="getFlightAllPriceInfoAction(item)"
                  class="operation"
                >
                  <span class="text" v-if="item.isSelectedTicket"
                    >已选第{{ getCurrent() }}程</span
                  >
                  <span class="text" v-else>选为第{{ getCurrent() }}程</span>
                  <span class="down_up_icon">
                    <img
                      src="~@/assets/img/up_icon.png"
                      alt=""
                      v-if="isShow && showFlightNo == item.flightKey"
                    />
                    <img src="~@/assets/img/down_icon.png" alt="" v-else />
                  </span>
                </div>
              </div>
            </div>
            <!-- 折叠层 -->
            <div v-show="showFlightNo == item.flightKey && isShow">
              <div class="serviceTag" v-if="item.journeyType && serviceTagList.length">
                <span class="title">{{item.journeyType == 1 ? '华夏通程专享' : '华夏联程专享'}}</span> &nbsp;&nbsp;
                <span class="content" @mouseover="hover = 'serviceTagList'"
                      @mouseleave="hover = 'none'">
                    {{ serviceTagList[0].title }}&nbsp;&nbsp;详情&nbsp;&nbsp;>
                </span>
              </div>
              <div class="fold_tooltip_wrap serviceTagList"
                  v-show="hover == 'serviceTagList'"
                  @mouseover="hover = 'serviceTagList'"
                  @mouseleave="hover = 'none'"
                >
                <div class="fold_tooltip">
                  <div class="flight_model_triangle_border"></div>
                  <p class="title">{{item.journeyType == 1 ? '华夏通程专享' : '华夏联程专享'}}</p>
                  <div class="tag" v-for="(tag,itag) in serviceTagList" :key="itag">
                    <div class="tt">·&nbsp;{{ tag.title }}</div>
                    <div class="cc">{{ tag.content }}</div>
                  </div>
                </div>
              </div>
              <div
                v-for="(item2, i) in allPrice"
                :key="i"
                class="fold_wrap clearfix"
              >
                <!-- 机舱类型 -->
                <div
                  class="fold_first"
                  @mouseover="showCabin(item,item2,i)"
                  @mouseleave="hideCabin()"
                >
                  <!-- 机舱类型弹框标题 -->
                  <div class="fold_tooltip_title">
                    <span>{{ item2.seatType }}</span>
                    <img class="img" src="~@/assets/img/question_icon.png" />
                  </div>
                  <!-- 弹框 -->
                  <div
                    class="fold_tooltip_wrap"
                    v-show="hover === 'foldTooltip' + i"
                    @mouseover="hover = 'foldTooltip' + i"
                    @mouseleave="hideCabin()"
                  >
                    <div class="fold_tooltip flight-ruleinfo-popup">
                      <!-- 小三角 -->
                      <div class="flight_model_triangle_border">
                        <!--ie6下需用，非ie6无需-->
                        <!-- <i class="before"></i><i class="after"></i> -->
                      </div>
                      <div v-if="showRuleInfoLoading" class="loadingmsg">
                        <img src="http://img.tuniucdn.com/img/1/common/loading-72x72.gif" /><span>请稍后...</span>
                      </div>
                      <template v-else>
                        <template v-for="(cabin,n) in item2.cabinInfo">
                          <div class="name">
                            <img src="~@/assets/img/circle.png" alt="" />
                            <span>
                              {{ cabin.departureCityName }}
                            </span>
                            <span>-</span>
                            <span>
                              {{ cabin.destinationCityName }}
                            </span>
                          </div>
                          <div class="content">
                            <div>预订限制：{{ cabin.priceDetailInfo }}</div>
                            <div>行李额：{{ cabin.baggageInfo }}</div>
                            <div>餐食：{{ cabin.dinner }}</div>
                            <div v-if="currentRuleInfo && currentRuleInfo[n]">
                              <div>退改签说明：</div>
                              <table border=1 class="refund-rule-info">
                                <template v-for="ruleInfo in currentRuleInfo[n]">
                                  <template v-if="ruleInfo.list && ruleInfo.list.length">
                                    <template v-for="rule in ruleInfo.list">
                                      <template v-if="rule.ruleFeeList && rule.ruleFeeList.length">
                                        <tr v-for="(ruleItem,rulei) in rule.ruleFeeList">
                                          <td v-if="rulei === 0" class="refund-rule-info-t" :rowspan="rule.ruleFeeList.length">{{ ruleInfo.psgType + rule.ruleName }}</td>
                                          <td>{{ ruleItem.name + ruleItem.value }}</td>
                                        </tr>
                                      </template>
                                    </template>
                                  </template>
                                  <tr v-if="ruleInfo.endorsementext">
                                    <td class="refund-rule-info-t">{{ruleInfo.psgType}}签转条件</td>
                                    <td>{{ ruleInfo.endorsementext }}</td>
                                  </tr>
                                  <tr v-if="ruleInfo.ruleRemark">
                                    <td class="refund-rule-info-t">{{ruleInfo.psgType}}退改详情</td>
                                    <td v-html="ruleInfo.ruleRemark"></td>
                                  </tr>
                                  <tr v-if="ruleInfo.cabinCodes">
                                    <td class="refund-rule-info-t">{{ruleInfo.psgType}}仓位</td>
                                    <td>{{ ruleInfo.cabinCodes }}</td>
                                  </tr>
                                </template> 
                              </table>
                            </div>
                          </div>
                        </template>
                      </template>
                    </div>
                  </div>
                </div>
                <!-- 限制类型标签 -->
                <div class="fold_first" style="margin-left:5px" v-if="item2.actionName">
                  <span 
                      class="limit" 
                      @mouseover="hover = 'ageLimitText' + i"
                      @mouseleave="hover = 'none'"
                      >{{item2.actionName}}</span>
                      <!-- 弹框 -->
                    <div
                      class="fold_tooltip_wrap"
                      v-show="item2.ageLimitDetailInfo && hover === 'ageLimitText' + i"
                      @mouseover="hover = 'ageLimitText' + i"
                      @mouseleave="hover = 'none'"
                    >
                      <div class="fold_tooltip">
                        <!-- 小三角 -->
                        <div class="flight_model_triangle_border">
                        </div>
                        {{ item2.ageLimitDetailInfo }}
                      </div>
                    </div>
                </div>
                <div class="fold_right_last clearfix">
                  <div class="fold_second">
                    <span class="add">{{ item2.priceShowTag }}</span>
                    <span class="unit">¥</span>
                    <span class="number">{{ item2.diffPrice }}</span>
                  </div>
                  <div class="fold_third">
                    <div
                      class="chose"
                      @click="
                        chosedTicket(
                          item,
                          item2,
                          item2.diffPrice,
                          item2.priceShowTag,
                          i
                        )
                      "
                    >
                      选择
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </template>
      <template v-else>
        <div style="text-align:center;width:100%;margin-top: 32px;">没有找到符合条件的，换个条件试试吧~</div>
      </template>
    </div>
  </div>
</template>

<script >
import flightTicket from "../../utils/flightTickets";
import utils from "../../utils/utils";
import requestParameter from "../../utils/requestParameter";
import rxjs from "../../utils/rxjs";
export default {
  name: "flightList",
  data() {
    return {
      hover: "none",
      currentOpenFlight:[],
      diffprice: [], //价格差
      showFlightNo: "",
      flightList: [],
      isShow: false,
      allPrice: [],
      serviceTagList:[], //华夏通程、联程权益信息
      // ticketIndex: -1, //当前选择的团队票 索引
      currentActionCode:'',
    };
  },
  methods: {
    formatFirstData: function () {
      let tabName = this.$store.getters.getTabName;
      let index = this.$store.getters.getCurrentIndex;
      let flightTicketObj = new flightTicket();
      if (tabName == "first") {
        let pkgTicketList =
          this.$store.getters.getRxjsMsg.parameter.groupTickets.pkgTicketList;
        let ticketIndex = this.$store.getters.getTicketIndex;
        let flightArr = [];
        if (pkgTicketList && pkgTicketList.length > 0) {
          if (ticketIndex >= 0) {
            flightArr = [
              pkgTicketList[ticketIndex].flightTicketLists[index - 1],
            ];
          } else {
            flightArr = pkgTicketList.map((item) => {
              return item.flightTicketLists[index - 1];
            });
          }
          let needCheck = this.$store.getters.getRxjsMsg.parameter.needCheck;
          let curFlightNos =
            this.$store.getters.getRxjsMsg.parameter.curFlightNos || [];
          let curResIds =
            this.$store.getters.getRxjsMsg.parameter.defaultResIds || [];

          flightArr.map((item) => {
            let priceFlightCabinList = item.priceFlightCabinList;
            let inlandFlightItemInfoLists = item.inlandFlightItemInfoLists;
            item.flightLength = inlandFlightItemInfoLists.length;
            inlandFlightItemInfoLists[0].addDay = 0;
            inlandFlightItemInfoLists[0].arrivedateAndTime =
              inlandFlightItemInfoLists[0].arrivalDate +
              "  " +
              inlandFlightItemInfoLists[0].arrivalTime;
            if (
              inlandFlightItemInfoLists[0].departureDate !=
              inlandFlightItemInfoLists[0].arrivalDate
            ) {
              inlandFlightItemInfoLists[0].addDay = 1;
            }
            item.isSelectedTicket = 0;

            //价格
            let totalPrice = item.price;
            let defaultPrice = flightTicketObj.defaultPrice(this.$store, index);
            let diffPrice = totalPrice - defaultPrice;
            item.isInt = diffPrice >= 0 ? true : false;
            item.diffPrice = Math.abs(diffPrice);

            if (!needCheck) {
              let curflightNo = curFlightNos[index - 1];
              let curResId = curResIds[index - 1];
              if (
                curflightNo &&
                curflightNo == item.inlandFlightItemInfoLists[0].flightNo &&
                item.diffPrice == 0 &&
                curResId == item.resId
              ) {
                item.isSelectedTicket = 1;
              }
            }

            inlandFlightItemInfoLists.map((item2) => {
              //经停
              let stopPoints = [];
              let stopAirPoint = [];
              let alltime = [];
              if (item2.stopPoints) {
                item2.stopPoints.map((item3) => {
                  stopPoints.push(item3.cityName);
                  stopAirPoint.push(item3.airPortName);
                  alltime.push(this.formatTime(item3.duration));
                });
                item.stopInfo = stopPoints.join(",");
                item.stopstopAirPointInfo = stopAirPoint.join(",");
                item.stopTime = alltime.join(",");
              } else {
                item.stopInfo = "";
              }
            });
            //中转
            if (
              item.transferFlag &&
              item.inlandTransferInfoList &&
              item.inlandTransferInfoList.length > 0
            ) {
              let transferAddress = [];
              let transferTime = [];
              item.inlandTransferInfoList.map((item6) => {
                transferAddress.push(item6.transferAddress);
                transferTime.push(this.formatTime(item6.transferTime));
              });
              item.transferTimeStr = transferTime.join(",");
              item.transferAddressStr = transferAddress.join(",");
            }
          });
        }
        this.flightList = flightArr;
        return flightArr;
      }
    },
    getCurrent: function (index) {
      return utils.getNumber(this.$store.getters.getCurrentIndex);
    },
    chosedTicket: function (item, item2, diffprice, taget, ticketIndex) {
      let flightTicketObj = new flightTicket();
      let tabName = this.$store.getters.getTabName;
      let currentIndex = this.$store.getters.getCurrentIndex;
      diffprice = taget == "+" || taget == true ? diffprice : -diffprice;
      this.diffprice[currentIndex - 1] = diffprice;
      let PriceDetailInfo = this.$store.getters.getPriceDetailInfo;
      let priceDetail = {
        adultPrice: tabName == "first" ? item.adultPrice : item2.adultPrice,
        adultFraPrice:
          tabName == "first" ? item.adultFraPrice : item2.adultFraPrice,
        childPrice: tabName == "first" ? item.childPrice : item2.childPrice,
        childFraPrice:
          tabName == "first" ? item.childFraPrice : item2.childFraPrice,
      };
      PriceDetailInfo[currentIndex - 1] = priceDetail;
      flightTicketObj.setChoseTickets(
        item,
        tabName,
        currentIndex,
        this.$store,
        item2
      );
      let flightTicketInfo = [];
      try {
        flightTicketInfo =
          this.$store.getters.getRxjsMsg.parameter.groupTickets.flightSegList;
      } catch (e) {}
      // debugger;
      let cnt = flightTicketInfo.length;
      if (flightTicketInfo.length > currentIndex) {
        //下一程
        let next = currentIndex + 1;
        this.$store.commit("setCurrentIndex", next);
        this.flightList = []; //清空当前数据
        // 缓存第一程政策票信息
        if (tabName !== "first" && item2.actionCode && item2.ageLimitDetailInfo) {
          this.currentActionCode = item2.actionCode;
        }
        //下一程请求
        if (tabName == "first") {
          // this.ticketIndex = ticketIndex;
          this.$store.commit("setTicketIndex", ticketIndex);
          this.$options.methods.formatFirstData.bind(this)();
        } else {
          flightTicketObj.cleanSecondTicketList(this.$store); //清空已有的数据，防止数据重复
          flightTicketObj.nextTickets(this.$store, next);
        }
      } else {
        let rxjsObj = new rxjs();
        const rxjs_subject = rxjsObj.getSubject();
        let rxjs_msg = { message: null, parameter: null };
        rxjs_msg.message = rxjsObj.getMessage("changeTickets");
        //预订页面  webpack 1.X  object 转化为array
        let choseTickets = JSON.parse(
          JSON.stringify(this.$store.getters.getChoseTicket)
        );

        let isSuggest = tabName == "first" ? 1 : 0; //是否自由组合,
        let airType = isSuggest ? 3 : 2;
        let resType = isSuggest ? 7 : 21;

        choseTickets.map((item) => {
          item.base.airType = airType;
          item.base.resType = resType;
        });

        rxjs_msg.parameter = {
          ticket: choseTickets,
          isSuggest: isSuggest,
          singlePriceInfo: PriceDetailInfo,
          diffprice: JSON.parse(JSON.stringify(this.diffprice)),
          directionId: this.$store.getters.getDirectionId,
        };
        console.log("last,当前的数据,选择的机票信息:", rxjs_msg);
        rxjs_subject.next(rxjs_msg);

        this.$store.commit("setDialogVisible", false);
      }
    },
    //获取自由组合对应航程下拉舱位选项数据
    getFlightAllPriceInfoAction: function (item) {
      //当前机票组合号是否和选择的机票航程组合号不相同 或者 没有展示
      if (this.showFlightNo != item.flightKey || !this.isShow) {
        this.showFlightNo = item.flightKey;
        this.currentOpenFlight = item.inlandConnectionInfoList;
        this.$store.commit("setFlightAllPriceInfo", []);
        let requestObj = new requestParameter(this.$store);
        let parameter = requestObj.getSecondAllTicketPrice(item);
        parameter.currentIndex = this.$store.getters.getCurrentIndex;
        parameter.currentActionCode = this.currentActionCode;
        this.$store.dispatch("getFlightAllPriceInfo", parameter);
        this.isShow = true;
      } else {
        this.isShow = false;
      }
    },
    formatTime(m,date1,date2) {
      let min = m;
      if (date1 && date2) {
        let diff = Math.abs(new Date(date2) - new Date(date1));
        min = Math.floor(diff / (1000 * 60));
      } 
      let hour = parseInt((min / 60).toString());
      let hourStr = hour >= 1 ? `${hour}h` : "";
      let minute = min % 60;
      let minStr = minute > 0 ? `${minute}m` : "";
      return hourStr + minStr;
    },
    //获取列表数据
    rendTicketList() {
      let tabName = this.$store.getters.getTabName;
      //列表数据
      let ticketsShow = [];
      //进入自由组合
      if (tabName == "second") {
        let flightTicketObj = new flightTicket();
        //排序规则
        let sort = this.$store.getters.getSort;
        //筛选项
        let filter = this.$store.getters.getFilter;
        //当前第几程
        let index = this.$store.getters.getCurrentIndex;
        //默认选中航程的机票总价
        let defaultPrice = flightTicketObj.defaultPrice(this.$store, index);
        //自由组合数据
        let flightData = { success: null };
        flightData = this.$store.getters.getFreeFlight;
        //整理机票列表数据
        ticketsShow = flightTicketObj.getTickets(
          tabName,
          flightData,
          defaultPrice,
          sort,
          filter,
          this.$store
        );
        //存在数据就关闭加载
        if (ticketsShow && ticketsShow.length > 0) {
          this.$store.commit("setLoading", false);
        }
      } else {
        this.$options.methods.formatFirstData.bind(this)();
        ticketsShow = this.flightList;
      }
      //返回列表数据
      return ticketsShow;
    },
    rendAllPrice() {
      let getFlightAllPriceInfo = this.$store.getters.getFlightAllPriceInfo;
      if (getFlightAllPriceInfo.length < 1) {
        return [];
      }
      let inlandDetailInfos = [];
      let inlandFlightOptions = ''
      try {
        inlandDetailInfos = getFlightAllPriceInfo.data.inlandDetailInfos;
        if (getFlightAllPriceInfo.data.inlandFlightOptions && getFlightAllPriceInfo.data.inlandFlightOptions.length &&
        getFlightAllPriceInfo.data.inlandFlightOptions[0].flightItems && getFlightAllPriceInfo.data.inlandFlightOptions[0].flightItems.length) {
          this.serviceTagList = getFlightAllPriceInfo.data.inlandFlightOptions[0].flightItems[0].serviceTagList;
        }
      } catch (e) {}

      if (inlandDetailInfos && inlandDetailInfos.length > 0) {
        let index = this.$store.getters.getCurrentIndex;
        let flightTicketObj = new flightTicket();
        let defaultPrice = flightTicketObj.defaultPrice(this.$store, index);
        inlandDetailInfos.map((item) => {
          let priceFlightCabinList = item.priceFlightCabinList;
          item.diffPrice = item.price - defaultPrice;
          item.priceShowTag = item.diffPrice >= 0 ? "+" : "-";
          item.diffPrice = Math.abs(item.diffPrice);
          let seatType = [];
          // 格式化信息 将往返程区分开
          let cabinInfo = [];
          if (priceFlightCabinList && priceFlightCabinList.length > 0) {
            priceFlightCabinList.map((item2,index) => {
              seatType.push(item2.seatTypeName);
              cabinInfo.push({
                priceDetailInfo: item2.priceDetailInfo,
                baggageInfo: item2.baggageInfo,
                dinner: item2.mealName,
                departureCityName: this.currentOpenFlight && this.currentOpenFlight[index] && this.currentOpenFlight[index].departureCityName,
                destinationCityName: this.currentOpenFlight && this.currentOpenFlight[index] && this.currentOpenFlight[index].destinationCityName
              })
            });
            // 政策票 年龄限制不存在中转航班
            item.ageLimitDetailInfo = priceFlightCabinList[0].ageLimitDetailInfo;
            item.actionName = priceFlightCabinList[0].actionName;
            item.actionCode = priceFlightCabinList[0].actionCode;
            item.seatType = seatType.join("-");
          }
          item.cabinInfo = cabinInfo;
        });
      } else {
        return [];
      }
      return inlandDetailInfos;
    },
    showCabin(flight,cabin,i) {
      this.hover = 'foldTooltip' + i;
      // 已有缓存的请求信息直接显示
      if (this.ruleInfoCache && this.ruleInfoCache[i]) {
        this.$store.commit("setCurrentRuleInfo",this.ruleInfoCache[i]);
        return 
      }
      // 请求退改签信息
      let requestObj = new requestParameter(this.$store);
      let parameter = requestObj.getRuleInfoParams(flight,cabin);
      this.$store.dispatch("getFlightRuleInfoP",{
        parameter,currentIndex:i
      });
    },
    hideCabin() {
      this.hover = 'none';
    }
  },

  watch: {
    "$store.getters.getTabName": {
      handler(newName, oldName) {
        if (newName == "first") {
          this.$options.methods.formatFirstData.bind(this)();
        } else {
          this.flightList = [];
        }
      },
      immediate: true,
      deep: true,
    },

    //推荐组合删除行程的时候渲染
    "$store.getters.getCurrentIndex": {
      handler(newName, oldName) {
        let tabName = this.$store.getters.getTabName;
        if (newName != oldName && tabName == "first") {
          this.$options.methods.formatFirstData.bind(this)();
        }
      },
      immediate: true,
      deep: true,
    },

    "$store.getters.getFilter": {
      handler(newName, oldName) {
        if (
          JSON.stringify(newName) != JSON.stringify(oldName) ||
          (JSON.stringify(newName) == JSON.stringify(oldName) &&
            JSON.stringify(newName) != "[]")
        ) {
          this.flightList = this.$options.methods.rendTicketList.bind(this)();
        }
      },
      immediate: true,
      deep: true,
    },
    "$store.getters.getSort": {
      handler(newName, oldName) {
        this.flightList = this.$options.methods.rendTicketList.bind(this)();
      },
      immediate: true,
      deep: true,
    },
    "$store.getters.getFlightAllPriceInfo"() {
      this.allPrice = this.$options.methods.rendAllPrice.bind(this)();
    },
  },
  computed: {
    getTabName() {
      let tabName = this.$store.getters.getTabName;
      return tabName;
    },
    showRuleInfoLoading() {
      return this.$store.state.showRuleInfoLoading
    },
    ruleInfoCache() {
      return this.$store.state.ruleInfoCache
    },
    currentRuleInfo() {
      return this.$store.state.currentRuleInfo
    }
  },
};
</script>
<style lang="scss">
.flight-main1 {
  height: 350px;
  overflow: auto;
}

.flight_info_wrap {
  border: 1px solid #eeeeee;
  margin-top: 5px;
  padding: 20px 15px;
  font-size: 12px;
  color: #666666;
  .first {
    width: 30%;
    float: left;
    margin: 4px 0;
  }
  .second {
    width: 10%;
    float: left;
  }
  .third {
    width: 15%;
    float: left;
  }
  .forth {
    width: 15%;
    float: left;
  }
  .fifth {
    width: 16%;
    float: left;
    margin: 6px 0;
  }
  .sixth,
  .sixth1 {
    // width: 10%;
    float: right;
    margin: 10px 0;
  }
  .sixth1-selected {
    background: #2dbb55 !important;
    color: white !important;
    border: #2dbb55 1px solid !important;
  }
  .first {
    .flight_logo {
      padding-right: 5px;
      img {
        width: 20px;
      }
    }
    .flight_logo,
    .flight_brief {
      display: inline-block;
      vertical-align: middle;
    }
    .flight_brief {
      padding-left: 5px;
      .name {
        font-size: 14px;
        color: #333;
        padding-bottom: 10px;
        line-height: 14px;
      }
      .flight_detail > div {
        float: left;
      }
      .flight_detail {
        .number {
          margin-right: 3px;
          border-bottom: 1px dotted #bbbbbb;
        }
        .detail_info {
          position: relative;
          .detail_name {
            color: #2dbb55;
            position: relative;
            cursor: pointer;
            font-size: 12px;
            .flight_ico {
              margin-right: 5px;
              width: 14px;
            }
          }
        }
      }
    }
  }
  .second {
    text-align: right;
    padding-right: 10x;
    .time {
      color: #333;
      font-size: 24px;
    }
    .address {
      color: #666666;
      font-size: 12px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
  .third {
    text-align: center;
    font-size: 12px;
    .arrow_icon_big {
      position: relative;
      width: 95px;
    }
    .bottom {
      position: relative;
      .title {
        color: #2dbb55;
        cursor: pointer;
      }
      .tooltiptrans_wrap {
        position: absolute;
        z-index: 999;
        width: 245px;
        .tooltiptrans {
          position: relative;
          top: 15px;
          padding: 15px;
          border: 1px solid #ffdcaf;
          box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);
          background: #fff;
          text-align: left;
          .item {
            padding-bottom: 5px;
          }
        }
      }
    }
  }
  .forth {
    text-align: left;
    .time {
      color: #333;
      font-size: 24px;
      .time_popover_wrap {
        display: inline-block;
        position: relative;
        top: -12px;
        .right_top {
          font-size: 12px;
          border-bottom: 1px dotted #cccccc;
          cursor: pointer;
        }
        .time_popover {
          position: absolute;
          z-index: 9999;
          .time_popover_inner {
            padding: 15px;
            border: 1px solid #ffdcaf;
            box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);
            background: #fff;
            font-size: 12px;
            color: #666666;
            position: relative;
            top: 13px;
            left: -9px;
            width: 161px;
          }
        }
      }
    }
    .address {
      color: #666666;
      font-size: 12px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
  .fifth {
    color: #ff6600;
    font-size: 12px;
    text-align: right;
    .add {
      font-size: 18px;
      padding-right: 3px;
    }
    .number {
      font-size: 26px;
      padding: 0px 3px;
    }
  }
  .sixth1 {
    border: 1px solid #ff8800;
    font-size: 12px;
    color: #ff8800;
    padding: 6px 7px;
    cursor: pointer;
    text-align: center;
  }
  .sixth {
    .operation {
      border: 1px solid #ff8800;
      text-align: center;
      font-size: 12px;
      color: #ff8800;
      padding: 6px 7px;
      cursor: pointer;
      display: inline-block;
      .down_up_icon {
        display: inline-block;
        padding-left: 5px;
        img {
          width: 7px;
          position: relative;
          top: -3px;
        }
      }
    }
  }
  .six-checked {
    .operation {
      background: #2dbb55;
      color: white;
      border: #2dbb55 1px solid;
    }
  }
  .fold_wrap {
    background: #fcfcfc;
    border-top: 1px solid #eeeeee;
    padding: 20px 36px;
    .fold_first {
      float: left;
      position: relative;
      .fold_tooltip_title {
        cursor: pointer;
        pointer-events: none;
        .img {
          width: 14px;
          position: relative;
          left: 3px;
          top: 2px;
        }
      }
      .fold_tooltip_wrap {
        position: absolute;
        width: 540px;
        z-index: 9999;
        .fold_tooltip {
          position: relative;
          top: 15px;
          padding: 15px;
          border: 1px solid #ffdcaf;
          box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);
          background: #fff;
          width: 340px;
          .name {
            color: #333;
            font-size: 14px;
            padding-bottom: 6px;
            img {
              width: 10px;
            }
          }
          .content {
            padding-left: 14px;
            white-space: pre-line;
          }
        }
      }
      .limit {
        font-family: PingFangSC-Regular;
        font-size: 12px;
        color: #FF742F;
        letter-spacing: 0;
        text-align: center;
        line-height: 16px;
        font-weight: 400;
        border: 1px solid #FF742F;
        border-radius: 2px;
        padding: 0 2px;
        margin-left: 4px;
      }
    }
    .fold_right_last {
      float: right;
      position: relative;
      .fold_second {
        float: left;
        color: #ff6600;
        padding-right: 15px;
        .add {
          font-size: 18px;
        }
        .unit {
          font-size: 14px;
        }
        .number {
          font-size: 22px;
        }
      }
      .fold_third {
        float: left;
        .chose {
          background: #ffa833;
          border-radius: 2px;
          border: 1px solid #ffa833;
          color: #fff;
          width: 60px;
          line-height: 26px;
          font-size: 14px;
          text-align: center;
          cursor: pointer;
        }
      }
    }
  }
}
.chosed_warp {
  border: #2dbb55 1px solid;
}
.free_flight_info_wrap {
  padding: 0px;
  .free_flight_info {
    padding: 20px 15px;
  }
}
// 弹框样式
.flight_info_wrap .flight_detail_tooltip_wrap {
  position: absolute;
  width: 540px;
  z-index: 9999;
  .bookInfo {
    .title {
      margin-top: 24px;
      font-size: 14px;
    }
    .detail {
      margin-top: 4px;
    }
  }
  .detail_tooltip {
    position: relative;
    top: 15px;
    padding: 15px;
    border: 1px solid #ffdcaf;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);
    background: #fff;
    .date {
      font-size: 14px;
      color: #333;
      padding-bottom: 5px;
    }
    .flight_detail_list {
      .city {
        color: #333;
        .fligtico {
          position: relative;
          top: 3px;
          width: 16px;
        }
        .arrow_icon {
          width: 14px;
          position: relative;
          top: -3px;
        }
      }
      .info > div {
        float: left;
        padding-right: 20px;
      }

      .info {
        padding-top: 10px;

        .start,
        .end {
          .time {
            text-align: right;
            font-size: 16px;
          }
          .name {
            color: #999999;
            font-size: 12px;
          }
        }
        .end {
          .time {
            text-align: left;
          }
        }
        .interval {
          text-align: center;
          color: #999999;
          .arrow_icon_big {
            position: relative;
            top: -5px;
            width: 95px;
          }
        }
        .company {
          font-size: 12px;
          color: #666666;
        }
      }
    }
  }
}

.serviceTag {
  padding-left: 35px;
  .title {
    font-weight: 700;
  }
  .content {
    color: #C1874D;
  }
}
.serviceTagList {
  margin: 20px;
  padding: 15px;
  border: 1px solid #ffdcaf;
  box-shadow: 0 2px 4px 0 rgba(0,0,0,.15);
  background: #fff;
  position: relative;
  .flight_model_triangle_border:before {
      top: -20px;
      left: 12px;
      border: 10px;
      border-style: dashed dashed solid dashed;
      border-color: transparent transparent #ffdcaf transparent
  }

  .flight_model_triangle_border:after,.flight_model_triangle_border:before {
      content: "";
      display: block;
      position: absolute;
      width: 0;
      height: 0;
      overflow: hidden;
      font-size: 0;
      line-height: 0
  }

  .flight_model_triangle_border:after {
      border: 9px;
      border-style: dashed dashed solid dashed;
      border-color: transparent transparent #fff transparent;
      left: 13px;
      top: -18px
  }
  .title {
    font-size: 14px;
    font-weight: 700;
  }
  .tag {
    margin-top: 10px;
    .tt {
      color: #C1874D;
      margin-bottom: 5px;
    }
  }
}
.refund-rule-info {
  border: 1px solid #eeeeee;
  width: 320px;
  tr,td {
      border: 1px solid #eeeeee;
  }
  &-t{
      width: 80px;
  }
  td {
      padding: 3px;
  }
}
.flight-ruleinfo-popup {
  max-height: 300px !important;
  overflow: auto;
}
</style>

